<template>
  <div
    class="modal fade"
    id="editSubworkModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    role="dialog"
    aria-labelledby="editSubworkModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content" v-if="show">
        <div class="modal-header shadow-sm">
          <h6 class="modal-title font-weight-bold" id="editSubworkModalLabel">
            <p class="mb-1">{{ subwork ? "Edit" : "Add" }} Subwork</p>
          </h6>
        </div>
        <div class="modal-body">
          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="small mb-1">
                    Road<sup class="text-danger">*</sup>
                  </label>
                </div>
                <div class="dropdown rounded w-100">
                  <button
                    class="w-100 btn btn-sm btn-block bg-white overflow-hidden dropdown-toggle position-relative d-flex justify-content-between align-items-center px-3"
                    style="font-size: 0.875rem; color: #495057"
                    type="button"
                    id="dropdownRoadButton"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span v-if="models.iraa_road">
                      ({{ models.iraa_road.attributes.owner }})
                      {{ models.iraa_road.attributes.name }}
                    </span>
                    <span v-else class="text-muted"> -- Select road </span>
                  </button>
                  <div
                    class="dropdown-menu py-0 w-100 shadow-sm p-0"
                    aria-labelledby="dropdownRoadButton"
                    style="height: 200px; overflow: hidden; font-size: 0.875rem"
                  >
                    <!-- <input
                      class="form-control form-control-sm"
                      placeholder="Search"
                      v-model="models.iraa_road"
                    /> -->
                    <div style="height: 100%; overflow-y: auto">
                      <button
                        v-for="road in roads"
                        :key="road.id"
                        class="border-bottom dropdown-item d-flex justify-content-between align-items-center px-3 py-2"
                        :class="{
                          'bg-subtle':
                            models.iraa_road && models.iraa_road.id == road.id,
                        }"
                        style="color: #495057"
                        @click="models.iraa_road = road"
                      >
                        ({{ road.attributes.owner }})
                        {{ road.attributes.name }}
                        <i
                          class="fas fa-check text-primary ml-2 small"
                          v-if="
                            models.iraa_road && models.iraa_road.id == road.id
                          "
                        />
                      </button>
                      <div
                        class="dropdown-item py-2 small text-center text-muted font-italic px-3 py-2 fs-8"
                      >
                        <span v-if="roads.length > 0"> End of list </span>
                        <span v-else>No road found</span>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="w-100 mt-2">
                    <div class="w-100 d-flex align-items-center justify-content-between border-bottom p-2" v-for="iraa_road of models.iraa_road" :key="iraa_road.id">
                      <p class="m-0">{{iraa_road.attributes.name}}</p>
                      <button class="btn btn-sm btn-danger" @click="() => { models.iraa_road = models.iraa_road.filter(road => road.id != iraa_road.id)}">Delete</button>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1"
                  >Name<sup class="text-danger">*</sup></label
                >
                <select
                  class="form-select form-select-sm"
                  v-model="models.name"
                >
                  <option :value="null" disabled class="text-muted">
                    ------ Select Name --------
                  </option>
                  <option v-for="(name, i) in names" :value="name" :key="i">
                    {{ name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="datetime">Date &amp; Time</label>
                <button
                  class="btn btn-sm bg-white w-100 d-flex justify-content-between align-items-center"
                  @click="showDatetimeSelector = true"
                >
                  <span>
                    {{
                      Helper.formatDate(models.datetime, true) ||
                      "Click to select date & time"
                    }}
                  </span>
                  <i class="fas fa-calendar-alt" />
                </button>
              </div>
            </div>
          </div>
          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="lat">Latitude</label>
                <input
                  type="text"
                  step="any"
                  min="0"
                  class="form-control form-control-sm"
                  id="lat"
                  placeholder="Enter latitude"
                  v-model="models.lat"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="lat">Longitude</label>
                <input
                  type="text"
                  step="any"
                  min="0"
                  class="form-control form-control-sm"
                  id="lat"
                  placeholder="Enter longitude"
                  v-model="models.lng"
                />
              </div>
            </div>
          </div>
          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="caption">Description</label>
                <textarea
                  rows="5"
                  class="form-control form-control-sm"
                  id="Caption"
                  placeholder="Enter description"
                  v-model="models.description"
                />
              </div>
            </div>
          </div>
          <div
            class="row mx-0 mb-3"
            v-for="key in [
              'img_before',
              'img_during',
              'img_after',
              'video_before',
              'video_after',
            ]"
            :key="key"
          >
            <div class="col">
              <label class="small mb-1 text-capitalize">
                {{ key.replace("_", " ") }}
              </label>
              <div>
                <div
                  class="image-grid clickable position-relative"
                  v-for="img in models[key]"
                  :key="`image-${img.id}`"
                  @click="openMediaPreview(Helper.formatMediaUrl(img))"
                >
                  <img :src="Helper.formatMediaUrl(img)" />
                  <button
                    class="btn btn-danger btn-sm position-absolute top-0 end-0"
                    @click.stop="removeFile(`models:${key}`, img)"
                  >
                    <i class="fas fa-trash-alt" />
                  </button>
                </div>
                <div
                  class="image-grid clickable position-relative"
                  v-for="(img, index) in filePreview[key]"
                  :key="`preview-${index}`"
                  @click="openMediaPreview(img.file)"
                >
                  <img :src="img.file" />
                  <button
                    class="btn btn-danger btn-sm position-absolute top-0 end-0"
                    @click.stop="removeFile(`filePreview:${key}`, img)"
                  >
                    <i class="fas fa-trash-alt" />
                  </button>
                </div>
                <div
                  class="image-grid image-grid-placeholder"
                  v-if="
                    !key.startsWith('video') ||
                    (models[key].length == 0 &&
                      fileInput[key].length == 0 &&
                      filePreview[key].length == 0)
                  "
                >
                  <button
                    class="btn h-100 w-100 fw-bold lh-sm text-capitalize"
                    @click="addFile(key.replace('_', ':'))"
                  >
                    <i class="fa-solid fa-file-upload fa-2x mb-2 d-block" />
                    Upload {{ key.replace("_", " ") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer shadow justify-content-between">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            @click="deleteSubwork()"
            v-if="subwork"
          >
            Delete Subwork
            <i class="fas fa-trash-alt ms-3" />
          </button>
          <div class="text-end flex-fill">
            <button
              type="button"
              class="btn btn-link btn-sm"
              @click="closeModal()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-sm btn-primary"
              @click="saveChanges()"
              :disabled="isProcessing"
            >
              <div
                class="spinner-border spinner-border-sm text-light"
                v-if="isProcessing"
              ></div>
              <span v-else>Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <datetime-selector
      v-if="showDatetimeSelector"
      mode="datetime"
      :date="models.datetime"
      @close="dateSelected"
    />
  </div>
</template>

<script>
import { Modal } from "bootstrap/dist/js/bootstrap.esm.min";
import DatetimeSelector from "@/components/DatetimeSelector";
import MediaViewer from "@/components/MediaViewer";
import Swal from "sweetalert2";

export default {
  name: "edit-subwork-modal",
  props: ["show", "subwork", "pavementId", "pavementData"],
  components: { MediaViewer, DatetimeSelector },
  data() {
    return {
      modal: null,
      showDatetimeSelector: false,
      isInitial: true,
      isProcessing: false,
      models: {
        name: null,
        datetime: null,
        lat: null,
        lng: null,
        iraa_road: null,
        img_before: [],
        img_during: [],
        img_after: [],
        video_before: [],
        video_after: [],
        description: null,
      },
      emptyModels: {
        name: null,
        datetime: null,
        lat: null,
        lng: null,
        iraa_road: null,
        img_before: [],
        img_during: [],
        img_after: [],
        video_before: [],
        video_after: [],
        description: null,
      },
      fileInput: {
        img_before: [],
        img_during: [],
        img_after: [],
        video_before: [],
        video_after: [],
      },
      filePreview: {
        img_before: [],
        img_during: [],
        img_after: [],
        video_before: [],
        video_after: [],
      },
      names: ["Resurface / Overlay", "Mill & Pave"],
    };
  },
  computed: {
    roads() {
      return this.pavementData.iraa_road;
    },
  },
  watch: {
    isProcessing: {
      handler() {
        this.Helper.toggleLoadingSpinner(this.isProcessing);
      },
      deep: true,
      immediate: true,
    },
    show: {
      async handler() {
        if (this.modal && this.show) {
          this.models = JSON.parse(JSON.stringify(this.emptyModels));

          Object.keys(this.fileInput).forEach((key) => {
            this.fileInput[key] = [];
          });

          Object.keys(this.filePreview).forEach((key) => {
            this.filePreview[key] = [];
          });

          if (this.subwork) {
            this.isInitial = true;

            this.$nextTick(() => {
              Object.keys(this.models).forEach((key) => {
                if (key.startsWith("video")) {
                  this.models[key] = this.subwork[key]
                    ? [this.subwork[key]]
                    : [];
                } else {
                  this.models[key] =
                    (this.subwork[key] && this.subwork[key]._id
                      ? this.subwork[key].id
                      : this.subwork[key]) ||
                    (Array.isArray(this.models[key]) ? [] : null);
                }
              });

              this.$nextTick(() => {
                this.isInitial = false;
              });
            });
          }

          this.modal.show();
        } else if (this.modal) {
          this.modal.hide();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async deleteSubwork() {
      Swal.fire({
        icon: "question",
        title: "Delete this subwork?",
        html: "This action is not reversible!",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Delete",
        confirmButtonColor: "red",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.isProcessing = true;

          await this.API.del(`pavement-works/${this.subwork.id}`);

          this.isProcessing = false;

          Swal.fire("Subwork deleted", "", "success").then(() => {
            this.closeModal(true);
          });
        }
      });
    },
    async saveChanges() {
      if (!this.models.name) {
        Swal.fire("Name is required", "", "error");

        return;
      }

      this.isProcessing = true;

      let method = "post";

      let url = "pavement-works";

      if (this.subwork) {
        method = "put";

        url = url += `/${this.subwork.id}`;
      }

      try {
        await this.uploadFileInput();

        const body = JSON.parse(JSON.stringify(this.models));

        body.img_before = body.img_before?.map((img) => img.id);
        body.img_during = body.img_during?.map((img) => img.id);
        body.img_after = body.img_after?.map((img) => img.id);

        body.video_before = body.video_before?.map((vid) => vid.id);
        body.video_after = body.video_after?.map((vid) => vid.id);

        if (!body.video_before.length) {
          body.video_before = null;
        }

        if (!body.video_after.length) {
          body.video_after = null;
        }

        if (!this.subwork) {
          body["pavement_case"] = this.pavementId;
        }

        await this.API[method](url, body);

        this.isProcessing = false;

        Swal.fire("Subwork Updated", "", "success").then(() => {
          this.closeModal(true);
        });
      } catch (error) {
        console.error(error);

        this.isProcessing = false;

        Swal.fire("Error updating subwork", JSON.stringify(error), "error");
      }
    },
    async uploadFileInput() {
      return new Promise(async (resolve, reject) => {
        for (let i = 0; i < Object.keys(this.fileInput).length; i++) {
          const key = Object.keys(this.fileInput)[i];

          if (this.fileInput[key].length) {
            const formData = new FormData();

            for (let index = 0; index < this.fileInput[key].length; index++) {
              const img = this.fileInput[key][index];

              formData.append("files", img.file, img.file.name);
            }

            const [call, error] = await this.Helper.handlePromise(
              this.API.postForm("upload", formData)
            );

            if (error) {
              return reject(error);
            } else {
              this.filePreview[key] = [];

              this.fileInput[key] = [];

              this.models[key] = (this.models[key] || []).concat(call.data);
            }
          }
        }

        resolve();
      });
    },
    removeFile(type, img) {
      const dataType = type.split(":")[0];
      const dataWhere = type.split(":")[1];

      this[dataType][dataWhere] = this[dataType][dataWhere].filter(
        (i) => i.id !== img.id
      );

      if (dataType == "filePreview") {
        this.fileInput[dataWhere] = this.fileInput[dataWhere].filter(
          (i) => i.id !== img.id
        );
      }
    },
    openMediaPreview(media) {
      this.$emit("open-media-preview", media);
    },
    addFile(type) {
      const mimeType = type.split(":")[0];

      const input = document.createElement("input");

      input.type = "file";

      input.multiple = mimeType == "video" ? false : true;

      input.accept = `${mimeType == "img" ? "image" : mimeType}/*`;

      input.onchange = (e) => this.fileChanged(e, type);

      input.click();
    },
    fileChanged(e, type) {
      const files = e.target.files;
      if (!files || !files.length) return;

      Object.values(files).forEach((file) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = (readerEvent) => {
          this.fileInput[type.replace(":", "_")].push({
            id: Date.now(),
            file: file,
          });

          this.filePreview[type.replace(":", "_")].push({
            id: Date.now(),
            file: readerEvent.target.result,
          });
        };
      });

      this.Helper.successToast(
        `${files.length} file${files.length > 1 ? "s" : ""} added`
      );
    },
    dateSelected(e) {
      if (e) {
        this.models.datetime = e;
      }

      this.showDatetimeSelector = false;
    },
    closeModal(response) {
      if (!this.isProcessing) {
        this.$emit("close", response);
      }
    },
  },
  mounted() {
    this.modal = new Modal(document.getElementById("editSubworkModal"));
  },
};
</script>